import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as data from './product4.json';

@Injectable({
  providedIn: 'root'
})
export class FcproductService {

  productData: any = (data as any).default;

  constructor() { }

  getProducts(): Observable<any> {
    return of(this.productData);
  }
}
